import AsyncStorage from "@react-native-async-storage/async-storage";

const PUSH_ENABLED_KEY = "push.enabled";

/** Local opt-out for push registration (synced to server via enabled flag). */
export async function getPushNotificationsEnabled(): Promise<boolean> {
    const value = await AsyncStorage.getItem(PUSH_ENABLED_KEY);
    return value !== "0";
}

export async function setPushNotificationsEnabled(enabled: boolean): Promise<void> {
    await AsyncStorage.setItem(PUSH_ENABLED_KEY, enabled ? "1" : "0");
}
